import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useLocation, useOutlet } from 'react-router-dom';
import { MenuResponse } from '../../context/models/accounts/MenuResponse';
import { useAuth } from '../../utils/AuthProvider';
import { NotAccess } from '../../components/container';

const acceptLink = (path: string, menus: MenuResponse[]) => {
	const checkMenu = menus.find((x) => path.includes(x.path));
	return checkMenu ? true : false;
};

const AdminLayout = () => {
	const { menus } = useAuth();
	const outlet = useOutlet();
	const location = useLocation();
	const [showSidebar, setShowSidebar] = useState(false);
	const [showSidebarMobile, setShowSidebarMobile] = useState(false);

	const isAccess = acceptLink(location.pathname, menus);

	useEffect(() => {
		setShowSidebarMobile(false);
	}, [location]);

	return (
        <div className="relative flex h-[100dvh] min-h-0 overflow-hidden bg-transparent">
            <div className="pointer-events-none absolute inset-0 -z-10 section-gradient" />
            <div className="pointer-events-none absolute inset-0 -z-10 grid-dot opacity-35" />
            <Sidebar
                isShowSideBar={showSidebar}
                isShowSideBarMobile={showSidebarMobile}
                showSideBar={() => {
                    setShowSidebar((prev) => !prev);
                }}
                setShowSidebarMobile={() => {
                    setShowSidebarMobile((prev) => !prev);
                }}
            />
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <Header showSideBar={() => setShowSidebarMobile((prev) => !prev)} />
                <main className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-3 py-4 sm:px-4">
                    {isAccess ? outlet : <NotAccess />}
                </main>
            </div>
        </div>
	);
};

export default AdminLayout;
